// extracted by mini-css-extract-plugin
export default {"loadingContainer":"AdminProtectedRoute_loadingContainer__q9Srt"};